/**
 * Login & Registration
 */
var loginInProgress = false;
var $loginBtn = $("#loginBox a.login");

// Done loading
var loginDoneLoading = function () {
  $loginBtn.text("Submit");
  $loginBtn.css("cursor", "cursor");
  loginInProgress = false;
};

// Perform login
var login = function ($form) {
  // Avoid submissions when already submitting
  if (loginInProgress) return;
  // Loading state
  loginInProgress = true;
  $loginBtn.css("cursor", "disabled");
  $loginBtn.text("Loading...");
  // Clear errors
  $form.children(".errors").html("");
  // HTTP API
  $.ajax({
    type: "POST",
    url: '/wp-admin/admin-ajax.php',
    data: $form.serialize()+'&'+$.param({action:'fw_login'}), //serializes the form's elements.
    dataType: "json",
    success: function (data) {
      console.log(data);
      if (data[0] === "success") {
        location.href = fullBase + "/create-your-profile/profile-details/#personal-info";
      } else if (data[0] === "dashboard") {
        location.href = fullBase + "/my-dashboard";
      }else if('redirect' in data && data.redirect.length){
        window.location=fullPath+"/"+data.redirect;
      } else if (data.error == "session-error") {
        location.href = fullBase + "?logged-out=2";
      } else if (data.errors.length > 0) {
        $form.children(".errors").html("");
        for (var i = 0; i < data.errors.length; i++) {
          $form.children(".errors").append('<p class="error">' + data.errors[i] + "</p>");
          loginDoneLoading();
        }
        if (data.hasOwnProperty("coppa") && data.coppa == 1) {
          setTimeout(function () {
            window.location = fullBase + "/student-registration/?action=new-coppa";
          }, 3000);
        }
      } else {
        $form.children(".errors").append('<p class="error">' + data + "</p>");
        loginDoneLoading();
      }
    },
    error: function (err) {
      console.warn("Login error:", err);
      loginDoneLoading();
    },
  });
};

$(document).on("ready", function () {
  $("a.login").on("click", function (e) {
    var $form = $(this).closest("form");
    e.preventDefault();
    login($form);
  });
  $("#loginBox input").on("keypress", function (e) {
    var $form = $(this).closest("form");
    if (e.which == 13) {
      login($form);
    }
  });
  $(document).on("keyup", "#PEZip", function () {
    var el = $(this);
    if (el.val().length === 5 && is_int(el.val())) {
      $.ajax({
        url: "https://api.zippopotam.us/us/" + el.val(),
        cache: false,
        dataType: "json",
        success: function (result, success) {
          $("input#PECity").val(result.places[0]["place name"]); /* Fill the data */
          $("select#PEState").val(result.places[0]["state abbreviation"]);
          $(".errors").hide();
        },
        error: function (result, success) {
          $(".errors").show();
        },
      });
    }
  });
    $(document).on('click','button.disabled, .btn.disabled',function(e){
      e.preventDefault();
    });
    $("form").submit(function () {
      $(this).find("button, .btn").addClass('disabled').toggleClass("loading");
      $(this).submit(function () {
        return false;
      });
      return true;
    });
    $(".switch-print").on("click", function (e) {
      e.preventDefault();
      $("body").addClass("apply-print");
    });
});
